import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DataCollection from '../../shared/DataCollection.js';
import DeleteButton from '../../shared/DeleteButton.js';
import '../../finances/FinanceCardList.css';

const ListCategoryCard = ({ row, onDeleted }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      className={`finance-card ${expanded ? 'expanded' : ''}`}
      onClick={() => setExpanded(e => !e)}
    >
      <div className="finance-card-main">
        <div className="finance-card-category">{row.name || '—'}</div>
        <div className="finance-card-chevron">{expanded ? '▲' : '▼'}</div>
      </div>
      {expanded && (
        <div className="finance-card-detail" onClick={e => e.stopPropagation()}>
          <div className="finance-card-actions">
            <DeleteButton
              collection="lists.categories"
              data={[row]}
              onComplete={onDeleted}
              onError={() => {}}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const ListCategoryCardList = ({ data, onRefresh }) => (
  <div className="finance-card-list">
    {(data || []).map(row => (
      <ListCategoryCard key={row._id} row={row} onDeleted={onRefresh} />
    ))}
    {(!data || data.length === 0) && (
      <div className="finance-card-empty">—</div>
    )}
  </div>
);

export const ListListsCategories = () => {
  const { t } = useTranslation();

  const columns = [
    {
      name:     t('category'),
      selector: row => row.name,
      sortable: true,
    },
  ];

  return (
    <DataCollection
      collection="lists.categories"
      columns={columns}
      sortField={1}
      mobileComponent={(data, onRefresh) => (
        <ListCategoryCardList data={data} onRefresh={onRefresh} />
      )}
    />
  );
};

export default ListListsCategories;
